interface WizardStepsProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
}

export const WizardSteps = ({
  currentStep,
  totalSteps,
  stepLabels,
}: WizardStepsProps) => {
  return (
    <div className="flex items-center justify-between">
      {stepLabels.map((label, index) => (
        <div key={index} className="flex flex-1 items-center">
          <div className="flex items-center gap-3">
            <div
              className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold transition-colors ${
                index < currentStep
                  ? 'bg-blue-600 text-white'
                  : index === currentStep
                    ? 'bg-blue-100 text-blue-600 ring-2 ring-blue-600'
                    : 'bg-gray-100 text-gray-400'
              }`}
            >
              {index + 1}
            </div>
            <span
              className={`text-sm font-medium ${
                index <= currentStep ? 'text-gray-900' : 'text-gray-400'
              }`}
            >
              {label}
            </span>
          </div>
          {index < totalSteps - 1 && (
            <div
              className={`mx-4 h-0.5 flex-1 transition-colors ${
                index < currentStep ? 'bg-blue-600' : 'bg-gray-200'
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};
